<script setup>
import { useFixturesStore } from '@/stores/fixtures';
import { storeToRefs } from 'pinia';

const fixtures = useFixturesStore()
const { sports } = storeToRefs(fixtures)
</script>

<template>
    <div class="w-full">
        <ul class="px-3 list-none flex space-x-4 w-full overflow-x-auto">
            <li>
                <RouterLink to="/search" class="flex flex-col items-center justify-center mt-1 ">
                    <div class="SearchBar_Icon"></div>
                    <p class="text-[11px] text-white font-bold mt-1 whitespace-nowrap">{{$t('app.8')}}</p>  
                </RouterLink>
            </li>
            <li>
                <RouterLink to="/ebd" class="flex flex-col items-center justify-center   mt-1">
                    <div class="Calendar" />
                    <p class="text-[11px] text-white font-bold mt-1 whitespace-nowrap">Events</p>
                </RouterLink> 
            </li>
            <li v-for="sport in sports">
                <RouterLink
                    :to="`/ps/${sport.si}`"
                    class="flex flex-col items-center justify-center py-2.5"
                >
                    <img :src="`/sport/${sport.si}.svg`" class="w-6 h-6" />
                    <p class="text-[11px] text-white font-bold mt-1 whitespace-nowrap">
                        {{ $te(`sports.${sport.si}`) ? $t(`sports.${sport.si}`) : sport.sn }}
                    </p>
                </RouterLink>
            </li>
        </ul>
    </div>
</template>


<style scoped>
.Calendar {
    mask-image: url('/calendar.svg');
    /* mask-size: 24px 24px; */
    height: 30px;
    width: 30px;
    @apply bg-neutral-300;
}


.SearchBar_Icon {
    mask-image: url('/search.svg');
    mask-size: 24px 24px;
    mask-repeat: no-repeat;
    mask-position: center;
    @apply bg-neutral-300;
    height: 30px;
    width: 30px;
}

/* .SearchBar_Text {
    font-size: 14px;
    color: #fff;
    font-weight: 700;
    line-height: 20px;
} */
</style>